import restCrudActions from '../../../np-crud/store/restCrudActions';
import { getAxiosInstance } from '../../../np-rest/rest';
import { snackActions } from '../../../sc-utilities/SnackBar';

// Create CRUD action creator
const crudActions = restCrudActions({
    endpointBasePath: 'license-prototype',
    pluginName: 'LICENSE',
    entityName: 'LICENSE_PROTOTYPE',
    fetchSuccessMessage: '',
    loadSuccessMessage: ''
});

// Fetch License prototype action creators
export const fetchLicensePrototypeInit = () => {
    return crudActions.fetchInit();
};
export const fetchLicensePrototypeStart = () => {
    return crudActions.fetchStart();
};
export const fetchLicensePrototypeSuccess = (fetchLicensePrototypeCount, listLicensePrototypeCount) => {
    return crudActions.fetchSuccess(fetchLicensePrototypeCount, listLicensePrototypeCount);
};
export const fetchLicensePrototypeFail = () => {
    return crudActions.fetchFail();
};

export const fetchLicensePrototypeCount = filterData => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchLicensePrototypeStart());
        try {
            let countRes = await rest.post("license-prototype/count", filterData);
            if (countRes.data && countRes.data.succeeded) {
                if (!countRes.data.result.data) {
                    dispatch(fetchLicensePrototypeSuccess(0, []));
                }
                return countRes.data.result.data
            }
            dispatch(fetchLicensePrototypeFail());
            snackActions.snackBar({
                message: `${countRes && countRes.data ? countRes.data.message : "Cannot fetch license prototypes."}`,
                options: {
                    variant: 'warning'
                }
            });
            return 0;
        } catch (error) {
            dispatch(fetchLicensePrototypeFail());
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch license prototypes."}`,
                options: {
                    variant: 'error'
                }
            });
            return 0;
        }
    }
}

export const fetchLicensePrototype = filterData => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchLicensePrototypeStart());
        try {
            let listRes = await rest.post("/license-prototype/list", filterData);
            if (listRes.data && listRes.data.succeeded) {
                dispatch(fetchLicensePrototypeSuccess(filterData.count, listRes.data.result.data));
                return listRes.data.result.data
            }
            dispatch(fetchLicensePrototypeFail());
            return []

        } catch (error) {
            dispatch(fetchLicensePrototypeFail());
            return []
        }
    }
}

// Create License  prototype action creators
export const createLicensePrototypeInit = () => {
    return crudActions.createInit();
};
export const createLicensePrototypeStart = () => {
    return crudActions.createStart();
};
export const createLicensePrototypeSuccess = licensePrototype => {
    return crudActions.createSuccess(licensePrototype);
};
export const createLicensePrototypeFail = error => {
    return crudActions.createFail(error);
};
export const createLicensePrototype = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(createLicensePrototypeStart());
        try {
            let res = await rest.post('/license-prototype/create', params);
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: `Successfully created license prototype.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            dispatch(createLicensePrototypeFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot create license prototype."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot create license prototype."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(createLicensePrototypeFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

// Delete License prototype action creators
export const deleteLicensePrototypeInit = () => {
    return crudActions.deleteInit();
};
export const deleteLicensePrototypeStart = () => {
    return crudActions.deleteStart();
};
export const deleteLicensePrototypeSuccess = deletedLicensePrototype => {
    return crudActions.deleteSuccess(deletedLicensePrototype);
};
export const deleteLicensePrototypeFail = error => {
    return crudActions.deleteFail(error);
};
export const deleteLicensePrototype = deleteData => {
    return async dispatch => {
        await crudActions.delete(dispatch, deleteData);
    };
};

// Edit License prototype action creators
export const editLicensePrototypeInit = () => {
    return crudActions.editInit();
};
export const editLicensePrototypeStart = () => {
    return crudActions.editStart();
};
export const editLicensePrototypeSuccess = editedLicensePrototype => {
    return crudActions.editSuccess(editedLicensePrototype);
};
export const editLicensePrototypeFail = error => {
    return crudActions.editFail(error);
};
export const editLicensePrototype = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(editLicensePrototypeStart());
        try {
            let res = await rest.post('/license-prototype/update', params);
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: `Successfully edited license prototype.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            dispatch(editLicensePrototypeFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot edit license prototype."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot edit license prototype."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(editLicensePrototypeFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

// Load License prototype action creators
export const loadLicensePrototypeInit = () => {
    return crudActions.loadInit();
};
export const loadLicensePrototypeStart = () => {
    return crudActions.loadStart();
};
export const loadLicensePrototypeSuccess = loadedLicensePrototype => {
    return crudActions.loadSuccess(loadedLicensePrototype);
};
export const loadLicensePrototypeFail = error => {
    return crudActions.loadFail(error);
};
export const loadLicensePrototype = id => {
    return async dispatch => {
        await crudActions.load(dispatch, id);
    };
};

// Bulk delete license prototypes 
export const bulkDeleteLicensePrototypeInit = () => {
    return crudActions.bulkDeleteInit()
};
export const bulkDeleteLicensePrototypeStart = () => {
    return crudActions.bulkDeleteStart();
};
export const bulkDeleteLicensePrototypeSuccess = result => {
    return crudActions.bulkDeleteSuccess(result);
};
export const bulkDeleteLicensePrototypeFail = error => {
    return crudActions.bulkDeleteFail(error);
};
export const bulkDeleteLicensePrototype = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(bulkDeleteLicensePrototypeStart());
        try {
            let res = await rest.post('/license-prototype/bulk-delete', params);
            if (res.data && res.data.succeeded) {
                dispatch(bulkDeleteLicensePrototypeSuccess(res.data.result.data));
                snackActions.snackBar({
                    message: `Successfully deleted license prototypes.`,
                    options: {
                        variant: 'success'
                    }
                });
                return
            }
            dispatch(bulkDeleteLicensePrototypeFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot bulk delete license prototypes."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot bulk delete license prototypes."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(bulkDeleteLicensePrototypeFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

export const listPermissions = (data, options) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('/permissions/list', { listAll: true, ...data }, options);
            if (res.data && res.data.succeeded) {
                let permissions = [];
                for (var permission of res.data.result.data) {
                    permissions.push({ value: permission.PermissionID, label: `${permission.Name}` });
                }
                return permissions;
            } else {
                if (res && res.canceled) {
                    return [];
                }
                snackActions.snackBar({
                    message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot list permissions"}`,
                    options: {
                        variant: 'warning'
                    }
                });
                return [];
            }
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
        }
    };
}